// extracted by mini-css-extract-plugin
export default {"sort":"SortSelect_sort__Ix07k","control":"SortSelect_control__DCwTR","select":"SortSelect_select__MkJJM","chevron":"SortSelect_chevron__wENVU"};